import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavHashLink as NavLink } from 'react-router-hash-link';

class Nav extends Component {
	constructor(props) {
		super(props);
		this.state = {
			checked: false
		};
	}

	onLinkClick = () => {
		this.setState({
			checked: !this.state.checked
		});
	};

	render() {
		const isActive = (path, match) =>
			!!(
				match ||
				path === document.location.pathname + document.location.hash
			);

		return (
			<div className="navigation">
				<input
					type="checkbox"
					className="navigation__checkbox"
					checked={this.state.checked}
					id="nav-toggle"
					readOnly
				/>
				<label
					htmlFor="nav-toggle"
					className="navigation__button"
					onClick={this.onLinkClick}
				>
					<span className="navigation__icon" />
					<FontAwesomeIcon
						icon={'times'}
						size="4x"
						className="navigation__close"
					/>
				</label>
				<div className="navigation__background">&nbsp;</div>
				<nav className="navigation__nav">
					<ul className="navigation__list">
						<li
							className="navigation__item"
							onClick={this.onLinkClick}
						>
							<NavLink
								className="navigation__link"
								activeClassName="navigation__link--active"
								to="#work"
								isActive={isActive.bind(
									this,
									`${document.location.pathname}#work`
								)}
							>
								Work
							</NavLink>
						</li>
						<li
							className="navigation__item"
							onClick={this.onLinkClick}
						>
							<NavLink
								className="navigation__link"
								activeClassName="navigation__link--active"
								to="#about"
								isActive={isActive.bind(
									this,
									`${document.location.pathname}#about`
								)}
							>
								About
							</NavLink>
						</li>
						<li
							className="navigation__item"
							onClick={this.onLinkClick}
						>
							<NavLink
								className="navigation__link"
								activeClassName="navigation__link--active"
								to="#contact"
								isActive={isActive.bind(
									this,
									`${document.location.pathname}#contact`
								)}
							>
								Contact
							</NavLink>
						</li>
					</ul>
				</nav>
			</div>
		);
	}
}

export default Nav;



// WEBPACK FOOTER //
// ./src/components/Nav.js